import { render } from "./footer.vue?vue&type=template&id=7e85cc1a&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=7e85cc1a&scoped=true&lang=css"

import exportComponent from "F:\\Vuedemo\\element-便签\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e85cc1a"]])

export default __exports__